import React from 'react';

import Jumbotron from 'components/modules/box/Jumbotron';
import JumbotronPanel from 'components/modules/box/JumbotronPanel';

type Props = {
  type: 'notContracted' | 'notAllowed';
};

const AbsencesRestricted: React.FC<Props> = ({ type }) => (
  <Jumbotron>
    <JumbotronPanel
      title="欠席連絡機能を利用できません"
      description={
        type === 'notContracted'
          ? '契約手続きが未完了のため利用できません。学校にお問い合わせください。'
          : '所属されている学校では欠席連絡機能を使用しない設定になっています。'
      }
    />
  </Jumbotron>
);

export default AbsencesRestricted;
